/**
 * Created by intellicar-rinas on 4/6/18.
 */
const messages = [
    {msg: 'Im not getting you'},
    {msg: 'Sorry, can you tell that again?'},
];

export default (name)=>{
    let index = Math.floor(messages.length * Math.random());
    return messages[index].msg;
}